import { defineComponent as w, useAttrs as V, computed as o, openBlock as r, createElementBlock as l, normalizeClass as v, unref as a, withDirectives as B, createElementVNode as m, mergeProps as S, vModelCheckbox as _, createBlock as g, createCommentVNode as p, renderSlot as z, createTextVNode as C, toDisplayString as N } from "vue";
import "./novoui-vuejs80.js";
/* empty css               */
import "./novoui-vuejs89.js";
/* empty css               */
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs8.js";
import "./novoui-vuejs11.js";
import A from "./novoui-vuejs12.js";
import "./novoui-vuejs48.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs17.js";
import "./novoui-vuejs18.js";
import { getSwitchStyleClasses as x } from "./novoui-vuejs63.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs24.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs34.js";
import "./novoui-vuejs35.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs37.js";
import "./novoui-vuejs38.js";
import "./novoui-vuejs42.js";
/* empty css                */
import "./novoui-vuejs45.js";
import "./novoui-vuejs47.js";
const D = ["disabled"], E = { class: "switch-slider" }, I = {
  key: 0,
  class: "switch-label"
}, we = /* @__PURE__ */ w({
  inheritAttrs: !1,
  __name: "NSwitch",
  props: {
    modelValue: { type: [String, Number, Boolean, Array] },
    hasLabel: { type: Boolean, default: !1 },
    hasIcon: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    size: { default: "medium" },
    type: { default: "primary" }
  },
  emits: [
    /**
     * Emits the value of the switch whenever it gets toggled
     */
    "update:modelValue"
  ],
  setup(n, { emit: c }) {
    const { class: u, ...d } = V(), t = n, f = c, i = o({
      get() {
        return t.modelValue;
      },
      set(e) {
        f("update:modelValue", e);
      }
    }), h = o(() => x(t)), b = o(() => t.modelValue ? "On" : "Off"), y = o(() => {
      switch (t.size) {
        case "large":
          return 20;
        case "medium":
        default:
          return 16;
      }
    });
    return (e, s) => (r(), l("label", {
      class: v([h.value, a(u)])
    }, [
      B(m("input", S({
        "onUpdate:modelValue": s[0] || (s[0] = (k) => i.value = k)
      }, d, {
        class: "switch-control",
        type: "checkbox",
        "aria-label": "checkbox",
        disabled: e.disabled
      }), null, 16, D), [
        [_, i.value]
      ]),
      m("span", E, [
        e.hasIcon ? (r(), g(a(A), {
          key: 0,
          class: "switch-icon",
          icon: "tick",
          size: y.value
        }, null, 8, ["size"])) : p("", !0)
      ]),
      e.hasLabel ? (r(), l("span", I, [
        z(e.$slots, "default", {}, () => [
          C(N(b.value), 1)
        ])
      ])) : p("", !0)
    ], 2));
  }
});
export {
  we as default
};
